import { type Options } from 'react-use-websocket';

import { makeMessage } from './helpers';
import { MessageAction, MessageType } from './types';

const HEARTBEAT_INTERVAL_MS = 20_000;

export const INIT_WS_OPTIONS: Options = {
  shouldReconnect: () => true,
  reconnectAttempts: 10,
  //attemptNumber will be 0 the first time it attempts to reconnect, so this equation results in a reconnect pattern of 1 second, 2 seconds, 4 seconds, 8 seconds, and then caps at 10 seconds until the maximum number of attempts is reached
  reconnectInterval: (attemptNumber) =>
    Math.min(Math.pow(2, attemptNumber) * 1000, 10000),
  share: true,
  heartbeat: {
    message: makeMessage(MessageType.HEARTBEAT, MessageAction.EXECUTE),
    interval: HEARTBEAT_INTERVAL_MS,
  },
};
